import type { QuickPrompt } from './InsightsPage.types';

export const quickPrompts: QuickPrompt[] = [
  {
    label: 'Analyze GMR by Industry',
    input: 'What are the Top 5 supplier industries based on GMR in 2025? Analyze each industry and provide a summary.',
  },
  {
    label: 'Find Account details',
    input: 'Account’s Current SRM, SRM team, region, and month over month GMR for 2025: <Account Name>',
  },
  {
    label: 'Research a specific market',
    input: 'Find the total GMR generated by a market in 2025: @market:',
  },
  {
    label: 'Use track events to analyze user behavior',
    input: 'Analyze this users track events with `user::logged-in` for the last month: @user:',
  },
];
